module.exports = __webpack_public_path__ + "static/media/icon-gift.0c9ef724.svg";